// Generated file, do not manually edit. Use php artisan app:generate-role-constants instead
const Role = {
  ADMINISTRATOR: 'administrator',
  CUSTOMER: 'customer',
  SHOP_OWNER: 'shop_owner'
}
export default Role
